import React from 'react';
import GivingCampaignForm from '../components/GivingCampaignForm';

const GivingCampaignFormApp = (props) => (
  <GivingCampaignForm {...props} />
);

export default GivingCampaignFormApp;
